import { MMTableView as LibraryTableView } from 'mmfintech-portal-commons'
import type { MMTableProps } from 'mmfintech-portal-commons/types'

type TableViewVariant = 'primary' | 'secondary'

type TableViewProps = MMTableProps<TableViewVariant>

export const MMTableView = {
  Table: (props: TableViewProps) => <LibraryTableView.Table {...props} />,
  Head: LibraryTableView.Head,
  Body: LibraryTableView.Body,
  Foot: LibraryTableView.Foot,
  Row: LibraryTableView.Row,
  HeadCell: LibraryTableView.HeadCell,
  Cell: LibraryTableView.Cell
}
